export const getFormattedList = (list, key, excludedFields = []) => {
  if (list.length === 0) return [];
  const formattedVarients = [];
  list.forEach((item) => {
    let newItem = item;
    const keyValue = item[key];
    excludedFields?.map((field) => {
      const { [field]: excludedKey, ...newUpdatedData } = newItem;
      newItem = { ...newUpdatedData };
    });
    if (`${keyValue}`.includes("virtual")) {
      if (!item.isDeleted) {
        formattedVarients.push([
          0,
          keyValue,
          {
            ...newItem,
          },
        ]);
      }
    } else {
      if (item.isDeleted) {
        formattedVarients.push([2, item.id, false]);
      } else {
        formattedVarients.push([
          1,
          keyValue,
          {
            ...newItem,
          },
        ]);
      }
    }
  });
  return formattedVarients;
};
